﻿//Read config valeus from hidden inputs, using JQuery
const CLIENT_ID = $("#MIClientId").val();
const AUTHORITY = $("#MIAuthority").val();
const REDIRECT_URI = $("#MIRedirectURI").val();
const PIP_CLIENT_ID = $("#PIP_CLIENT_ID").val();

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: REDIRECT_URI
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case msal.LogLevel.Error:
            console.error(message);
            return;
          case msal.LogLevel.Info:
            // console.info(message);
            return;
          case msal.LogLevel.Verbose:
            console.debug(message);
            return;
          case msal.LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
const loginRequest = {
  scopes: ["User.Read"],
  extraQueryParameters: {domain_hint: "nestle.com"}
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
const tokenRequest = {
  scopes: ["User.Read"],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

const apiRequest = {
  scopes: [`api://${CLIENT_ID}/access_as_user`],
  extraQueryParameters: {domain_hint: "nestle.com"}
};

const microsoftGraphApiRequest = {
  scopes:
  ["Directory.Read.All", "User.Read", "User.ReadBasic.All"]
};

const glossaryPlatfromTokenRequest = {
  scopes: [`api://4140efde-b8b0-49d8-9bf2-3ba2479d3886/access_as_user`]
}

const pipTokenRequest = {
  scopes: [`api://${PIP_CLIENT_ID}/access_as_user`]
}